import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL } from "@/lib/constants";

const DEFAULT_IMAGE = "https://emeraedu.com.br/og-emera.jpg";
const DEFAULT_TITLE = "Cursos de arbitragem para advogados";
const DEFAULT_DESCRIPTION =
  "Escola da Arbitralis SA, câmara com +30.000 casos resolvidos. Cursos online de arbitragem, IA no Direito e ECA Digital com quem atua em casos reais.";

interface SEOHeadProps {
  title?: string;
  description?: string;
  url?: string;
  /** Canonical alternativo (ex.: páginas duplicadas de campanha). Default: url. */
  canonicalUrl?: string;
  image?: string;
  type?: "website" | "article" | "profile";
  keywords?: string[];
  llmSummary?: string;
  articleMeta?: {
    publishedTime?: string;
    authorName?: string;
    tags?: string[];
  };
}

const SEOHead = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, url = SITE_URL, canonicalUrl, image, type = "website", keywords, llmSummary, articleMeta }: SEOHeadProps) => {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl || url} />


      {keywords && keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      {llmSummary && <meta name="summary" content={llmSummary} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      {ogImage === DEFAULT_IMAGE && <meta property="og:image:width" content="1200" />}
      {ogImage === DEFAULT_IMAGE && <meta property="og:image:height" content="630" />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="pt_BR" />

      {/* Article meta */}
      {type === "article" && articleMeta?.publishedTime && (
        <meta property="article:published_time" content={articleMeta.publishedTime} />
      )}
      {type === "article" && articleMeta?.authorName && (
        <meta property="article:author" content={articleMeta.authorName} />
      )}
      {type === "article" && articleMeta?.tags?.map((tag) => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHead;
